import { React, useState } from "react";
import { PinInput } from "react-input-pin-code";

import {
  Grid,
  Typography,
  Paper,
  useTheme,
  Box,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Stack,
  Checkbox,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

//user Imports

// import { NAV_ROUTES } from "../../Services/Routes/App";

import { MainRoutes } from "../../Services/Routes/App";
import { signupValidation } from "../../Services/validation/Signup";
import { Formik, Form } from "formik";
import { MainUrls } from "../../Services/Routes/API";
import { headersPost } from "../../Services/API";

// import { StorageKeys } from "../../Services/Storage";

import { LimospayIcon, LimospayTextIcon, BackIcon } from "../../Svg";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LoadCard from "../../components/LoadCard";
import SuccessCard from "../../components/SuccessCard";

//initial values

const initialValues = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  bvn: "",
  password: "",
  confirmPassword: "",
};

//styling

const useStyles = makeStyles({
  flexSetting: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
});

const Signup = () => {
  //states

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [pageNumber, setpageNumber] = useState(1);
  const [checkBoxvalue, setCheckBoxvalue] = useState(false);
  const [otpValue, setOtpValue] = useState(["", "", "", "", "", ""]);
  const [sendEmail, setSendEmail] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConPassword, setShowConPassword] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  // theme

  const theme = useTheme();

  const classes = useStyles();

  //navigate

  const navigate = useNavigate();

  const changeState = (newState) => {
    setAcceptedTerms(newState);
  };
  const NavigateToLogin = () => {
    navigate(MainRoutes?.root);
  };

  const submitHandler = (values) => {
    const data = {
      user: {
        first_name: values?.firstName,
        last_name: values?.lastName,
        phone_number: values?.phoneNumber,

        email: values?.email,

        bvn: values?.bvn,
        password: values?.password,
      },
    };
    // setOpen(true);

    headersPost(MainUrls?.signup, data)
      .then((res) => {
        // setOpen(false);

        if (res?.status === 200 && res?.data?.success) {
          // setAlertOpen(true);
          // setSuccessModal(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setpageNumber(3);
          // navigate(-1);
          // navigate(MainRoutes?.root);

          // localStorage.setItem(StorageKeys?.token, res?.data?.token);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(-1);
        }
        setAlertOpen(true);
        setAlertMsg(response?.statusText);
        setAlertIcon("warning");
        localStorage.clear();
        // navigate(-1);
      });
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertOpen(false);
  };

  const modalClose = () => {
    setSuccessModal(false);
  };

  const Validationfunction = (values) => {
    if (
      values?.email !== "" &&
      values?.firstName !== "" &&
      values?.lastName !== "" &&
      values?.bvn !== "" &&
      values?.phoneNumber !== ""
    ) {
      setpageNumber(pageNumber + 1);
    }
  };
  const pageNumberChangeMethod = () => {
    setpageNumber(pageNumber - 1);
  };
  const initialValues = {
    otp_code: "",
  };
  const submitHandlerPinCode = () => {
    const data = {
      user: {
        otp_code: otpValue,
        email: sendEmail,
      },
    };
    setOpen(true);
    headersPost(MainUrls?.VERIFY_USER, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          // setAlertOpen(true);
          setSuccessModal(true);
          setAlertMsg(res?.data?.message);
          // setAlertIcon("success");
          // navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(-1);
        }
        setAlertOpen(true);

        setAlertMsg(response?.data?.message);

        setAlertIcon("warning");
        localStorage.clear();
        // navigate(-1);
      });
  };
  return (
    <Box>
      <Grid container>
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{
            // height: "90vh",
            width: "100%",
          }}
        >
          <Box
            display={"flex"}
            // justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            // height={"100%"}
            width={"100%"}
            margin={"auto"}
          >
            <Box mt={10}>
              <LimospayIcon />
            </Box>
            <Typography
              margin={"auto"}
              mt={2}
              color={"text.grayText"}
              fontWeight="bold"
              variant="h4"
              display={"flex"}
              width={"55%"}
              height={"55%"}
              alignItems={"center"}
            >
              Providing secure Payment Infrasture
            </Typography>

            <Typography
              margin={"auto"}
              mt={5}
              color={"text.grayText"}
              variant="subtitle"
              display={"flex"}
              width={{ xs: "70%", sm: "60%", md: "55%" }}
              height={"55%"}
              alignItems={"center"}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem
              iaculis lectus vitae interdum vestibulum amet urna blandit.
              Scelerisque iaculis auctor nibh justo in pretium. Praesent
            </Typography>
          </Box>
        </Grid>

        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            // height={"100%"}
            width={{ xs: "85%", sm: "70%" }}
            margin={"auto"}
          >
            <Paper
              elevation={1}
              sx={{
                borderTop: `5px solid  ${theme.palette.primary.main}`,
                borderRadius: 1,
                marginTop: 3,
              }}
            >
              {pageNumber === 2 && (
                <Box sx={{ width: "10%", position: "absolute" }} mt={5} ml={2}>
                  <Button onClick={pageNumberChangeMethod}>
                    <BackIcon />
                  </Button>
                </Box>
              )}

              <Formik
                initialValues={initialValues}
                validationSchema={signupValidation}
                onSubmit={submitHandler}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleSubmit,
                  setFieldTouched,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Box
                      margin={"auto"}
                      width={"80%"}
                      mt={5}
                      fontSize={"15px"}
                    ></Box>
                    <Box className={classes.flexSetting} mt={4}>
                      <LimospayTextIcon />
                    </Box>

                    {pageNumber === 1 && (
                      <Box
                        margin={"auto"}
                        width={"80%"}
                        mt={{ xs: 2, sm: 3 }}
                        fontSize={"15px"}
                      >
                        <Typography mt={2} className={classes.flexSetting}>
                          Create Account with us
                        </Typography>
                        <TextField
                          fullWidth
                          name="firstName"
                          variant="standard"
                          label="First Name"
                          value={values?.firstName}
                          error={
                            touched?.firstName && Boolean(errors?.firstName)
                          }
                          helperText={touched?.firstName && errors?.firstName}
                          onChange={handleChange}
                          sx={{
                            marginBottom: 1,
                          }}
                        ></TextField>
                        <TextField
                          fullWidth
                          name="lastName"
                          variant="standard"
                          label="Last Name"
                          value={values?.lastName}
                          error={touched?.lastName && Boolean(errors?.lastName)}
                          helperText={touched?.lastName && errors?.lastName}
                          onChange={handleChange}
                        ></TextField>
                        <TextField
                          fullWidth
                          name="phoneNumber"
                          variant="standard"
                          label="Phone Number"
                          value={values?.phoneNumber}
                          error={
                            touched?.phoneNumber && Boolean(errors?.phoneNumber)
                          }
                          helperText={
                            touched?.phoneNumber && errors?.phoneNumber
                          }
                          onChange={handleChange}
                        ></TextField>
                        <TextField
                          fullWidth
                          name="email"
                          variant="standard"
                          label="Email Address"
                          value={values?.email}
                          error={touched?.email && Boolean(errors?.email)}
                          helperText={touched?.email && errors?.email}
                          onChange={(e) => {
                            setSendEmail(e.target.value);
                            handleChange(e);
                          }}
                        ></TextField>
                        <TextField
                          fullWidth
                          name="bvn"
                          variant="standard"
                          label="BVN"
                          value={values?.bvn}
                          error={touched?.bvn && Boolean(errors?.bvn)}
                          helperText={touched?.bvn && errors?.bvn}
                          onChange={handleChange}
                        ></TextField>

                        <Button
                          variant="contained"
                          type="submit"
                          fullWidth
                          onClick={(e) => {
                            e.preventDefault();
                            let upcomingErrors = [];
                            let fieldsTouched = [];
                            [
                              "firstName",
                              "lastName",
                              "email",
                              "phoneNumber",
                              "bvn",
                            ].forEach((fieldName, index, array) => {
                              setFieldTouched(fieldName, true, true).then(
                                () => {
                                  const field_touched = touched?.[fieldName];
                                  const field_errors = errors?.[fieldName];
                                  if (field_errors) {
                                    upcomingErrors.push(field_errors);
                                  }
                                  if (field_touched) {
                                    fieldsTouched.push(field_touched);
                                  }
                                  if (
                                    !upcomingErrors.length &&
                                    fieldsTouched.length === array.length
                                  ) {
                                    setpageNumber(pageNumber + 1);
                                  }
                                }
                              );
                            });
                          }}
                          sx={{
                            marginTop: 2,
                            height: theme.spacing(5),
                          }}
                        >
                          Next
                        </Button>
                      </Box>
                    )}
                    {pageNumber === 2 && (
                      <Box
                        margin={"auto"}
                        width={"80%"}
                        mt={{ xs: 2, sm: 3 }}
                        fontSize={"15px"}
                      >
                        <FormControl sx={{ width: "100%" }} variant="standard">
                          <TextField
                            id="standard-adornment-password"
                            type={showPassword ? "text" : "password"}
                            value={values.password}
                            variant="standard"
                            label="Password"
                            onChange={handleChange("password")}
                            error={
                              touched?.password && Boolean(errors?.password)
                            }
                            helperText={touched?.password && errors?.password}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => {
                                    setShowPassword(!showPassword);
                                  }}
                                  // onMouseDown={() => {

                                  //   setShowPassword(
                                  //     showPassword
                                  //       ? showPassword
                                  //       : !showPassword
                                  //   );
                                  // }}
                                  onMouseUp={() => {
                                    setShowPassword(
                                      showPassword
                                        ? !showPassword
                                        : showPassword
                                    );
                                  }}
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>

                        {/* <TextField
                          fullWidth
                          name="password"
                          type="password"
                          variant="standard"
                          label="Password"
                          value={values?.password}
                          error={touched?.password && Boolean(errors?.password)}
                          helperText={touched?.password && errors?.password}
                          onChange={handleChange}
                          sx={{
                            marginBottom: 1,
                          }}
                        ></TextField> */}
                        <FormControl
                          sx={{ width: "100%", marginTop: 1 }}
                          variant="standard"
                        >
                          <TextField
                            id="standard-adornment-conpassword"
                            type={showConPassword ? "text" : "password"}
                            variant="standard"
                            label="Confirm Password"
                            value={values.confirmPassword}
                            onChange={handleChange("confirmPassword")}
                            error={
                              touched?.confirmPassword &&
                              Boolean(errors?.confirmPassword)
                            }
                            helperText={
                              touched?.confirmPassword &&
                              errors?.confirmPassword
                            }
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => {
                                    setShowConPassword(!showConPassword);
                                  }}
                                  // onMouseDown={() => {

                                  //   setShowPassword(
                                  //     showPassword
                                  //       ? showPassword
                                  //       : !showPassword
                                  //   );
                                  // }}
                                  onMouseUp={() => {
                                    setShowConPassword(
                                      showConPassword
                                        ? !showConPassword
                                        : showConPassword
                                    );
                                  }}
                                >
                                  {showConPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                        {/* <TextField
                          fullWidth
                          name="confirmPassword"
                          type="password"
                          variant="standard"
                          label="Confirm Password"
                          value={values?.confirmPassword}
                          error={
                            touched?.confirmPassword &&
                            Boolean(errors?.confirmPassword)
                          }
                          helperText={
                            touched?.confirmPassword && errors?.confirmPassword
                          }
                          onChange={handleChange}
                        ></TextField> */}

                        <Stack direction={"row"} ml={-1} mt={2}>
                          <Checkbox
                            checked={acceptedTerms}
                            onChange={(e) => {
                              changeState(e.currentTarget.checked);
                            }}
                          />
                          <Typography variant={"subtitle2"}>
                            Creating account means you have selected our terms &
                            Conditions
                          </Typography>
                        </Stack>

                        <Button
                          variant="contained"
                          type="submit"
                          fullWidth
                          disabled={!acceptedTerms}
                          sx={{
                            marginTop: 5,
                            height: theme.spacing(5),
                          }}
                        >
                          Next
                        </Button>
                      </Box>
                    )}

                    {pageNumber === 3 && (
                      <Box padding={{ xs: 1, sm: 2.5, md: 3.5 }}>
                        <Box
                          padding={3}
                          display={"flex"}
                          justifyContent={"space-around"}
                          flexDirection={"column"}
                        >
                          <Typography
                            marginBottom={2}
                            variant="body1"
                            textAlign={"center"}
                          >
                            Verify Your Account
                          </Typography>
                          <Typography
                            sx={{ color: "gray" }}
                            variant="subtitle2"
                            textAlign={"center"}
                          >
                            Please enter the OTP sent to your mobile number
                          </Typography>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"}>
                          {/* <PinInput
                            length={6}
                            initialValue=""
                            onChange={(otp) => {
                              setOtpValue(otp);
                            }}
                            type="numeric"
                            inputMode="number"
                            style={{ padding: "3px" }}
                            inputStyle={{
                              borderColor: "black",
                              borderTop: "1px",
                              borderLeft: "1px",
                              borderRight: "1px",
                              width: theme.spacing(3.8),
                              margin: theme.spacing(0.7),
                            }}
                            inputFocusStyle={{ borderColor: "blue" }}
                            onComplete={(value, index) => {}}
                            autoSelect={true}
                            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                          /> */}

                          <PinInput
                            values={otpValue}
                            length={6}
                            onChange={(otp, index, values) => {
                              setOtpValue(values);
                            }}
                            validate={/^[0-9]*$/}
                            size="lg"
                            placeholder=""
                            containerStyle={{
                              display: "grid",
                              gridAutoColumns: "max-content",
                              gridAutoFlow: "column",
                              justifyContent: "center",
                              margin: "1rem 0",
                            }}
                            inputStyle={{
                              backgroundColor: "rgb(248, 249, 250)",
                              borderRadius: "0.3rem",
                              fontSize: "1.2rem",
                              margin: " 0.2rem",
                              height: "3rem",
                              outline: "none",
                              textAlign: "center",
                              transitionDuration: "250ms",
                              transitionProperty:
                                "background, color, border, box-shadow, transform",
                              width: "3rem",
                            }}
                          />
                        </Box>
                        <Box paddingX={{ xs: 3, sm: 5 }}>
                          <Button
                            variant="contained"
                            onClick={submitHandlerPinCode}
                            disabled={
                              !otpValue.filter((val) => val !== "").length
                            }
                            fullWidth
                            sx={{
                              marginTop: theme.spacing(2),
                              height: theme.spacing(5),
                              marginBottom: theme.spacing(-3),
                            }}
                          >
                            Next
                          </Button>
                        </Box>
                      </Box>
                    )}

                    <Box className={classes.flexSetting} mt={2}>
                      <Typography mb={3}>
                        Already have an account?{" "}
                        <Button
                          // underline="none"
                          component={"span"}
                          variant="text"
                          onClick={() => NavigateToLogin()}
                          sx={{
                            color: theme.palette.primary.main,
                          }}
                        >
                          Login
                        </Button>
                      </Typography>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Paper>
          </Box>
        </Grid>
      </Grid>
      {/* <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <LoadCard
        open={open}
        tittle={"Please wait while we create an account for you."}
      />
      <SuccessCard
        title={"Wallet"}
        msg={alertMsg}
        open={successModal}
        onClose={() => {
          modalClose();
          navigate(MainRoutes?.root);
        }}
      />
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={alertIcon}
          sx={{
            backgroundColor: theme.palette?.success?.light,
            color: theme.palette.text?.primary,
          }}
        >
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};
export default Signup;
